import React, { FC } from 'react'

import styled from 'styled-components'

export interface PrimaryDottedButtonProps extends React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> {}

const Text = styled.div`
  text-align: center;
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  border-bottom: 1px dashed ${({ theme }) => theme.color.darkGrey};
`

const StyledDottedButton = styled.button`
  padding: 0;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  color: ${({ theme }) => theme.color.darkGrey};
  background: transparent;
  border: none;
  cursor: pointer;
  &:hover,
  &:focus-visible {
    outline: none;
    ${Text} {
      border-bottom-color: transparent;
    }
  }
  &:active {
    ${Text} {
      border-bottom-style: solid;
    }
  }
  &:disabled {
    cursor: not-allowed;
    ${Text} {
      border-bottom-style: dashed;
      color: ${({ theme }) => theme.color.mediumGrey};
      border-bottom-color: ${({ theme }) => theme.color.mediumGrey};
    }
  }
`

export const PrimaryDottedButton: FC<PrimaryDottedButtonProps> = ({
  children,
  ...restProps
}) => (
  <StyledDottedButton {...restProps}>
    <Text>{children}</Text>
  </StyledDottedButton>
)
